const INIT_STATE = {
  show: false,
  detail: {},
  device: null,
};

export function SpiModalReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case 'SHOW_SPI_MODAL': {
      return {
        ...state,
        show: true,
      };
    }
    case 'HIDE_SPI_MODAL': {
      return {
        ...state,
        show: false,
      };
    }
    case 'SET_MESSAGE_SPI_MODAL': {
      return {
        ...state,
        detail: action.payload,
      };
    }
    case 'SET_DEVICE_SPI_MODAL': {
      return {
        ...state,
        device: action.payload,
      };
    }
    case 'RESET_SPI_MODAL': {
      return {
        ...INIT_STATE,
      };
    }
    default:
      return state;
  }
}
